'use client'
import '@dynamic-labs/sdk-api-core';
import '../../constants/values.js';
import '@dynamic-labs/utils';
import '../../../../../_virtual/_tslib.js';
import '@dynamic-labs/multi-wallet';
import '../../../shared/logger.js';
import '../../constants/colors.js';
import 'react-international-phone';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../../shared/consts/index.js';
import '../../../store/state/nonce/nonce.js';
import '../../../store/state/projectSettings/projectSettings.js';
import { getEnabledEmbeddedWalletProviders } from '../getEnabledEmbeddedWalletProviders/getEnabledEmbeddedWalletProviders.js';
import '../../../config/ApiEndpoint.js';
import '../../../store/state/user/user.js';
import '../../../locale/locale.js';
import '../../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../../store/state/primaryWalletId/primaryWalletId.js';

const isAllowedToLinkWallet = (projectSettings, verifiedCredentials, multiWallet) => {
    if (multiWallet)
        return true;
    if (!projectSettings || !(verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.length))
        return false;
    // no embedded wallet providers are enabled and user doesn't have any wallet linked
    const canLinkOnSingleWallet = !getEnabledEmbeddedWalletProviders(projectSettings).length &&
        !verifiedCredentials.some((vc) => vc.walletProvider);
    return canLinkOnSingleWallet;
};

export { isAllowedToLinkWallet };
